export default "__VITE_ASSET__ssX6avLh__"